import { AccessRecoveryCabinet } from './client';
import { AccessRecoveryCabinetServer } from './server';

export const normalizeAccessRecoveryCabinet = (
  raw: AccessRecoveryCabinetServer
): AccessRecoveryCabinet => ({
  cabinetId: raw.cabinet_id,
  name: raw.name,
  role: raw.role
});
